import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./auth/msalConfig";
import App from "./App";
import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

// Handle the redirect response before React mounts. If the cached interaction
// state is stale (e.g. nonce mismatch, orphaned code_verifier), clear the cache
// so the user lands on Login instead of looping on /auth/callback.
try {
  await msalInstance.handleRedirectPromise();
} catch (err) {
  console.warn("MSAL redirect handling failed, clearing auth cache", err);
  await msalInstance.clearCache();
}

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </MsalProvider>
  </React.StrictMode>
);
